// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"676":"adc558ed","825":"8c0eb75d"}[chunkId] + ".chunk.js";
};